module.exports = __webpack_public_path__ + "static/img/no-task.8287a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/no-task.png
// module id = UtdV
// module chunks = 215